import i18n from "../lib/i18n";

const PaginationInfo = ({ page, itemsPerPage, totalNumberOfItems }) => {
  if (totalNumberOfItems === 0) {
    return null;
  }

  return i18n.t("js.components.pagination_info.info", {
    from: (page - 1) * itemsPerPage + 1,
    to: Math.min(page * itemsPerPage, totalNumberOfItems),
    total: totalNumberOfItems,
  });
};

export default PaginationInfo;
